import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import classnames from 'classnames';
import { Icon, Button } from '@iq/react-components';
import { refreshData, getPollingActive } from '../../../bundles/application';

const PollingRefresh = ({ siteId }) => {
  const dispatch = useDispatch();
  const isPolling = useSelector(getPollingActive);

  const spinningClass = classnames({ polling: isPolling });

  return (
    <div className="polling-refresh">
      <Button
        activity="secondary"
        className="refresh-variables-button"
        onClick={() => dispatch(refreshData(siteId))}
        icon={
          <Icon
            icon="he-load"
            size="s"
            className={spinningClass}
          />
        }
        disabled={isPolling}
        tooltip="Refresh now"
      />
    </div>
  );
};

export default PollingRefresh;
